import { CarRateCodeFee } from './car-detail';
import { FeeOverrideType } from './models/fee-types';

export class WaiverReasonDictionary {
  [key: number]: string
}

export class FeeOverrideRequest {
  feeOverrideType: FeeOverrideType;
  feeWaiverCode: string;
  feeWaiverReason: string;
  feeDiscountAmount: number;
  currency: string;
  feeAmount: number;
}

export interface FeeOverrideResponse {
  feeOverrideToken: string;
}

export class FeeOverrideData {
  currencyCode = 'USD';

  constructor (type: FeeOverrideType, token: string, amount: number) {
    this.type = type;
    this.token = token;
    this.amount = amount;
  }

  token: string;
  amount: number;
  type: FeeOverrideType;
}

export interface FeeOverrideDialogData {
  implementedFee: CarRateCodeFee;
  feeOverride: FeeOverrideData;
}


